module.exports = __webpack_public_path__ + "static/media/banner-catalog.b8efc473.jpg";